import React from 'react'
import { Layout, Row, Col, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'
import {
  BookOutlined,
  MedicineBoxOutlined,
  ToolOutlined,
  MailOutlined,
  PhoneOutlined,
  WechatOutlined,
} from '@ant-design/icons'
import './AppFooter.css'

const { Footer } = Layout
const { Title, Text } = Typography

const AppFooter: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Footer className="app-footer">
      <div className="footer-content">
        <Row gutter={[48, 32]}>
          <Col xs={24} sm={12} md={6}>
              <div className="footer-brand">
              <div className="footer-logo">
                <img 
                  src="/images/logo.png" 
                  alt="岐黄智医" 
                  className="footer-logo-image"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none'
                  }}
                />
                <span className="footer-logo-text">岐黄智医</span>
              </div>
              <Text className="footer-tagline">
                传承千年智慧，创新现代医疗
              </Text>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Title level={5} className="footer-title">功能模块</Title>
            <ul className="footer-links">
              <li onClick={() => navigate('/textbook')}>
                <BookOutlined /> 智能教材
              </li>
              <li onClick={() => navigate('/diagnosis')}>
                <MedicineBoxOutlined /> 智能诊疗
              </li>
              <li onClick={() => navigate('/tools')}>
                <ToolOutlined /> 智能工具
              </li>
            </ul>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Title level={5} className="footer-title">联系我们</Title>
            <ul className="footer-contact">
              <li>
                <MailOutlined /> contact@tcmai.com
              </li>
              <li>
                <PhoneOutlined /> 400-xxx-xxxx
              </li>
            </ul>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Title level={5} className="footer-title">关注我们</Title>
            <ul className="footer-social">
              <li>
                <WechatOutlined /> 微信公众号
              </li>
              <li>
                <WechatOutlined /> 官方微博
              </li>
            </ul>
          </Col>
        </Row>
        <div className="footer-bottom">
          <Text>© 2024 岐黄智医 - 中医药人工智能网络平台. All rights reserved.</Text>
        </div>
      </div>
    </Footer>
  )
}

export default AppFooter

